<template>
    <div class="experience">

        <div class="main">
            <p class="title">工作经历<span class="sign">必填</span>
                <span class="add"
                      @click="interactive('ruleForm')">
                    <i class="el-icon-plus"></i>添加
                </span>
            </p>
            <div class="mould"
                 v-for="(item,index) in workList"
                 :key="index">
                <p>{{item.conpanyName}}<span>{{item.startDate|formatDate}}-{{item.endDate|formatDate}}
                        <el-button v-show="buttonshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="edit(index)">编辑</el-button>
                        <el-button v-show="buttonshow"
                                   type="text"
                                   @click="open(index)">删除</el-button>
                        <el-button v-show="!buttonshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="editthis(item.id,index)">编辑该项</el-button>
                        <el-button v-show="!buttonshow"
                                   type="text"
                                   @click="openthis(item.id,item.personId)">删除该项</el-button>
                    </span>
                </p>
                <p>{{item.position}}</p>
                <div class="entry"
                     style="white-space:pre-line">
                    {{item.workDuty}}
                    <!-- <p v-html="item.workDuty"></p> -->
                    <!-- <p>2. 负责产品的UI视觉设计、图标设计、交互设计、界面设计；</p>
                    <p>3. 撰写视觉设计规范，整理UI的设计规划；</p>
                    <p>4. 跟踪产品的用户反馈，对现有产品的可用性测试和评估，提出改善方案，不断优化用户体验；</p> -->
                </div>
            </div>
            <el-form v-show="showed"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <h3>编辑工作经历:</h3>
                <el-form-item label="公司名称"
                              prop="conpanyName">
                    <el-input maxlength="30"
                              v-model="ruleForm.conpanyName"></el-input>
                </el-form-item>
                <el-form-item label="职位名称"
                              prop="position">
                    <el-input maxlength="30"
                              v-model="ruleForm.position"></el-input>
                </el-form-item>
                <el-form-item label="在职时间"
                              prop="startDate">
                    <el-date-picker v-model="ruleForm.startDate"
                                    type="date"
                                    :clearable="false"
                                    @change="changeendstartDate"
                                    placeholder="开始时间">
                    </el-date-picker>
                    <el-form-item label=""
                                  prop="endDate">
                        <el-date-picker style="margin-left:10px;"
                                        :clearable="false"
                                        v-model="ruleForm.endDate"
                                        @change="changeendDate"
                                        type="date"
                                        placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="工作职责"
                              prop="workDuty">
                    <el-input type="textarea"
                              maxlength="500"
                              placeholder="请输入工作职责，以回车隔开"
                              v-model="ruleForm.workDuty"></el-input>
                </el-form-item>
                <el-form-item v-show="buttonshow"
                              class="center">
                    <el-button type="primary"
                               @click="subit('ruleForm')">保存</el-button>
                    <el-button @click="rest('ruleForm')">取消</el-button>
                </el-form-item>
                <el-form-item v-show="!buttonshow"
                              class="center">
                    <el-button type="primary"
                               @click="subitsaveworkexperience('ruleForm')">确认</el-button>
                    <el-button @click="restsaveworkexperience('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    saveworkexperience,
    selectworkexperience,
    delectworkexperience
} from "@/api/apiall";
export default {
    data() {
        return {
            buttonshow: false,
            // type: "",
            showed: false,
            workList: [],
            number: 999,
            ruleForm: {
                id: "",
                personId: "",
                conpanyName: "",
                position: "",
                startDate: "",
                endDate: "",
                workDuty: ""
            },
            rules: {
                conpanyName: [
                    {
                        required: true,
                        message: "请输入公司名称",
                        trigger: "blur"
                    }
                ],
                position: [
                    {
                        required: true,
                        message: "请输入职位名称",
                        trigger: "blur"
                    }
                ],
                startDate: [
                    {
                        required: true,
                        message: "请输入开始时间",
                        trigger: "change"
                    }
                ],
                endDate: [
                    {
                        required: true,
                        message: "请输入结束时间",
                        trigger: "change"
                    }
                ],
                workDuty: [
                    {
                        required: true,
                        message: "请输入工作职责",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.buttonshow = false;
            } else {
                this.buttonshow = true;
            }
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.buttonshow = false;
        } else {
            this.buttonshow = true;
        }
        // if (
        //     sessionStorage.getItem("userId") != null ||
        //     sessionStorage.getItem("userId") != undefined
        // ) {
        //     this.searchselectworkexperience();
        // }
    },
    mounted() {},
    methods: {
        interactive(formName) {
            this.number = 999;
            this.ruleForm.id = "";
            if (this.workList.length < 10) {
                this.showed = true;
                this.$refs[formName].clearValidate();
            } else {
                this.$message({
                    message: "最多添加10条",
                    type: "warning"
                });
            }
        },
        changeendstartDate() {
            if (this.ruleForm.startDate > this.ruleForm.endDate) {
                this.ruleForm.endDate = "";
            }
        },
        searchselectworkexperience() {
            this.ruleForm.personId = sessionStorage.getItem("informationId");
            selectworkexperience({ personId: this.ruleForm.personId }).then(
                res => {
                    if (res.status === 2000) {
                        this.workList = res.data;
                    }
                }
            );
        },
        subitsaveworkexperience(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.personId = sessionStorage.getItem(
                        "informationId"
                    );
                    saveworkexperience(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.ruleForm = {};
                            this.$refs[formName].clearValidate();
                            this.showed = false;
                            this.searchselectworkexperience();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        restsaveworkexperience(formName) {
            this.$refs[formName].resetFields();
            this.showed = false;
        },
        changeendDate() {
            if (this.ruleForm.startDate > this.ruleForm.endDate) {
                this.ruleForm.endDate = "";
                this.$message({
                    type: "warning",
                    message: "结束时间必须大于开始时间!"
                });
            }
        },
        edit(index) {
            this.showed = true;
            // this.type = 1;
            this.number = index;
            // conpanyName: "",
            // position: "",
            // startDate: "",
            // endDate: "",
            // workDuty: ""
            this.ruleForm = { ...this.workList[index] };
            // this.ruleForm.conpanyName = this.workList[index].conpanyName;
            // this.ruleForm.position = this.workList[index].position;
            // this.ruleForm.startDate = this.workList[index].startDate;
            // this.ruleForm.endDate = this.workList[index].endDate;
            // this.ruleForm.workDuty = this.workList[index].workDuty;
            // this.workList.splice(index, 1);
        },
        editthis(item, index) {
            this.showed = true;
            this.number = index;
            this.ruleForm = { ...this.workList[index] };
        },
        open(index) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.del(index);
                this.$message({
                    type: "success",
                    message: "删除成功!"
                });
            });
        },
        del(index) {
            this.workList.splice(index, 1);
        },
        openthis(item,personId) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                delectworkexperience({ id: item,personId:personId }).then(res => {
                    if (res.status === 2000) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.searchselectworkexperience();
                    }
                });
            });
        },
        subit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.number != 999) {
                        this.workList[this.number] = this.ruleForm;
                    } else {
                        this.workList.push(this.ruleForm);
                    }
                    this.ruleForm = {};
                    // setTimeout(() => {
                    this.$refs[formName].clearValidate();
                    // }, 100);
                    this.showed = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        rest(formName) {
            // if (this.type == "1") {
            //     this.workList.push(this.ruleForm);
            //     this.ruleForm = {};
            // } else {
            // this.$refs[formName].resetFields();
            this.ruleForm = {};
            // }
            this.showed = false;
        },
        save(formName) {
            this.$emit("experienceByValue", this.workList);
        }
    }
};
</script>


<style scoped lang="scss">
.experience {
    width: 900px;
    background-color: #fff;
    float: left;
    .mould {
        p {
            margin-top: 20px;
            font-size: 15px;
            span {
                float: right;
                color: #666;
            }
        }
        .entry {
            font-size: 14px;
            color: #666;
            line-height: 26px;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        .title {
            font-size: 18px;
            color: #333;
            .add {
                cursor: pointer;
                float: right;
                color: #fabe00;
                font-size: 15px;
            }
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 20px;
            .el-input,
            .el-select {
                width: 230px;
            }
            h3 {
                font-size: 17px;
                margin: 20px 0;
                font-weight: 500;
            }
            .el-date-editor {
                width: 120px;
                /deep/ .el-input__inner {
                    padding-right: 0;
                }
            }
            .el-textarea {
                width: 740px;
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
        .center {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 30px;
        }
    }
}
</style>
